export default __webpack_public_path__ + "a334a0b23bc072cc94f8d8b3d86a1d9e.png";